import { lazy, Suspense, useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuthContext } from "../firebase-files/hooks/useAuthContext";

// components
// import NavbarBottom from "../default-components/NavbarBottom";
import ColorsComponent from "../default-components/ColorsComponent";
import NavbarBottomTwo from "../default-components/NavbarBottomTwo";
import PartnerSlider from "../default-components/PartnerSlider";
import Notification from "../default-pages/notifications/Notification";
import PGLoginSignUp from "../firebase-files/login/PGLoginSignUp";
// import PhoneLoginSignup from "../firebase-files/login/PhoneLoginSignup";
import Cart from "../default-components/Cart";
import ChatBot from "../ai-Cloudify/chatBot/ChatBot";
// admin
// import PGAdminDashboard from "../allRoles/admin/PGAdminDashboard";
import PGAdminUser from "../allRoles/admin/PGAdminUser";
import AppSettings from "../allRoles/admin/PGAppSettings/AppSettings";
import AddPhoto from "../firebase-files/AddPhoto";
// import AddDocument from "../firebase-files/AddDocument";
import CreateTicket from "../chatboard/CreateTicket";
import TicketDetail from "../chatboard/TicketDetail";
import BookingList from "../default-pages/bookings/BookingList";
import ProductDetails from "../default-pages/products details/ProductDetails";
import ProductImages from "../default-pages/products details/ProductImages";

// styles
import "../App.css";
import AdminSettings from "../allRoles/admin/AdminSettings";
import CustomerDashboard from "../allRoles/customer/dashboard/CustomerDashboard";
// import PGProducts from "../default-pages/products/PGProducts";
import PGFaq from "../default-pages/faq/PGFaq";
// import PrivacyPolicy from "../default-pages/privacy policy/PrivacyPolicy";
import ReturnPolicy from "../default-pages/return policy/ReturnPolicy";
import PGBusinessThreeProfile from "../templates/business/businessThree/businessThreePages/PGBusinessThreeProfile";
// import TermsAndCondition from "../default-pages/terms & condition/TermsAndCondition";
import FloatingSpeedDial from "../default-components/FloatingSpeedDial";
import PGCareer from "../default-pages/career/PGCareer";
import ContactUs from "../default-pages/contact us/ContactUs";
import PGEvents from "../default-pages/events/PGEvents";
import PGGallery from "../default-pages/gallery/PGGallery";
import PGTeam from "../default-pages/team/PGTeam";
import { useDocument } from "../firebase-files/hooks/useDocument";
// import TemplateEditSidePopup from "../default-components/TemplateEditSidePopup";
// import QRScannerComponent from "../default-components/QRScannerComponent";
import AddCategories from "../allRoles/admin/AddCategories";
import Address from "../default-components/Address";
import BlogAndArticles from "../default-components/BlogAndArticles";
import PGAttendance from "../default-pages/attendance/PGAttendance";
import PGHrAttendance from "../default-pages/attendance/PGHrAttendance";
import CorporateTwoPolicy from "../templates/corporate/corporateTwo/corporateTwoPages/CorporateTwoPolicy";
import CorporateTwoTerms from "../templates/corporate/corporateTwo/corporateTwoPages/CorporateTwoTerms";

// IMPORT BOOKINGS PAGE AND COMPONENTS
// import BasicAddBooking from "../default-pages/add booking/BasicAddBooking";
import AccommodationBookingDashboard from "../bookings/accommodation booking/AccommodationBookingDashboard";
import AccommodationCheckout from "../bookings/accommodation booking/AccommodationCheckout";
import AccommodationPropertiesDetails from "../bookings/accommodation booking/AccommodationPropertiesDetails";
import PGAccommodationBooking from "../bookings/accommodation booking/PGAccommodationBooking";
import Checkout from "../default-components/Checkout";
import OrderDetails from "../default-components/OrderDetails";
import OrderSummary from "../default-components/OrderSummary";
import Wishlist from "../default-components/Wishlist";
import QuickPickup from "../default-components/quickPickup/QuickPickup";
import QuickPickupProductAdd from "../default-components/quickPickup/QuickPickupProductAdd";
import QuickPickupSummary from "../default-components/quickPickup/QuickPickupSummary";
import Reorder from "../default-components/reorder/Reorder";
import AllContactData from "../default-pages/contact us/AllContactData";
import PGBusinessThreeAboutUs from "../templates/business/businessThree/businessThreePages/PGBusinessThreeAboutUs";

//ocr
// import Ocrdemo from "../default-components/ocr/Ocrdemo";

import ProductDetailTwo from "../default-components/productsTwo/ProductDetailTwo";
import Productstwo from "../default-components/productsTwo/Productstwo";
import OfflineOrder from "../default-components/offlineOrder/OfflineOrder";
import LoyaltyPanel from "../default-components/loyaltyPanel/LoyaltyPanel";
import DeadCart from "../default-components/deadCart/DeadCart";
import ProfileTwo from "../default-components/profileTwo/ProfileTwo";
import PricePage from "../default-components/PricePage";
// import AdminRoutes from "../default-components/adminPanel/AdminRoutes";
import OnlinePayment from "../default-components/OnlinePayment";
import OrderReceiptView from "../default-components/OrderReceiptView";

// IMPORT COMPONENT  OF FIRESTORE DB DYNAMIC PAGES
import DynamicPages from "../default-components/DynamicPages";
import PageNotFound from "../default-components/PageNotFound";
import CustomerRoutes from "../default-components/customerPanel/CustomerRoutes";
import LeaveHistory from "../default-components/leaveManagment/LeaveHistory";
import MyGridLayout from "../default-components/new-page-using-drag-and-drop/MyGridLayout";
import UserDetail from "../default-components/userDetail/UserDetail";
import BlogDetails from "../default-pages/blog-details/BlogDetails";
import PGSubscription from "../default-pages/subscription/PGSubscription";
import PGVendorRegistration from "../default-components/vendorPanel/PGVendorRegistration";
import PGVendorManageAccount from "../default-components/vendorPanel/PGVendorManageAccount";

const excludedPaths = [
  "/",
  "/profile",
  "/aboutus",
  "/dashboard",
  "/my-plants",
  "/service-attendance",
  "/service-visitor",
  "/videos",
];

function GlobalRoute() {
  const location = useLocation();
  const { user } = useAuthContext();
  const upcomingBookings = 6;
  const confirmedBookings = 100;
  const cancelledBookings = 2;

  // lazy loading try
  const PGProducts = lazy(() => import("../default-pages/products/PGProducts"));
  const AdminRoutes = lazy(() =>
    import("../default-components/adminPanel/AdminRoutes")
  );
  const OrdersPage = lazy(() => import("../default-components/OrdersPage"));

  const [currentModeStatus, setCurrentModeStatus] = useState("dark");

  const { document: dbTextContentDocuments, error: dbTextContentError } =
    useDocument("settings", "PWA");

  const { document: dbDisplayModeDocuments, error: dbDisplayModeError } =
    useDocument("settings", "mode");

  const { document: dbLaunchingSoonDocuments, error: dbLaunchingSoonError } =
    useDocument("settings", "launchingPage");

  const { document: dbPagesControlDocuments, error: dbPagesControlError } =
    useDocument("settings", "pagesControl");

  const { document: loginPopupDocuments, error: loginPopupError } = useDocument(
    "settings",
    "LoginPopup"
  );

  const { document: dbAppTypeDocuments, error: dbAppTypeError } = useDocument(
    "settings",
    "AppType"
  );

  const { document: dbTemplatesDocuments, error: dbTemplatesError } =
    useDocument("settings", "templates");

  // const [isLoading, setIsLoading] = useState(true);
  const [activeTemplate, setActiveTemplate] = useState(null);

  useEffect(() => {
    const fetchActiveTemplate = async () => {
      try {
        // Access the activeTemplate value from the fetched document
        if (dbTemplatesDocuments) {
          setActiveTemplate(dbTemplatesDocuments.activeTemplate);
        }
      } catch (error) {
        console.error("Error fetching active template:", error);
      } finally {
        // setIsLoading(false);
      }
    };

    fetchActiveTemplate();
  }, [dbTemplatesDocuments]);

  // PWA CODE START
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  function startChromeInstall() {
    if (deferredPrompt) {
      deferredPrompt.prompt();
    }
    setinstallPopupDiv(false);
  }

  const [installPopupDiv, setinstallPopupDiv] = useState(true);
  const closeInstallPopup = () => {
    setinstallPopupDiv(false);
  };
  // PWA CODE END

  useEffect(() => {
    //First time set display mode from db to useState variable and also store the same value in localStorage
    if (
      localStorage.getItem("mode") === null ||
      localStorage.getItem("mode") === "null" ||
      localStorage.getItem("mode") === ""
    ) {
      // console.log('dbdisplaymode: ', dbDisplayModeDocuments && dbDisplayModeDocuments.displayMode)
      setCurrentModeStatus(
        dbDisplayModeDocuments && dbDisplayModeDocuments.displayMode
      );
      localStorage.setItem(
        "mode",
        dbDisplayModeDocuments && dbDisplayModeDocuments.displayMode
      );
    }
    // Function to handle changes in localStorage
    const handleStorageChange = () => {
      const storedValue = localStorage.getItem("mode");
      setCurrentModeStatus(storedValue);
    };

    // Call the function initially
    handleStorageChange();

    // Listen for changes in localStorage
    window.addEventListener("storage", handleStorageChange);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [dbDisplayModeDocuments]);

  return (
    <>
      {/* <TemplateEditSidePopup /> */}
      <div className={"global-route-full-content"}>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/adminsettings" element={<AdminSettings />}></Route>
            <Route path="/add-categories" element={<AddCategories />}></Route>
            {/* <Route path="/dashboard" element={<PGDashboard />}></Route> */}
            <Route
              path="/customerdashboard"
              element={
                <CustomerDashboard
                  upcomingBookings={upcomingBookings}
                  confirmedBookings={confirmedBookings}
                  canceledBookings={cancelledBookings}
                />
              }
              // element={
              //   user && user ? (
              //     <CustomerDashboard
              //       upcomingBookings={upcomingBookings}
              //       confirmedBookings={confirmedBookings}
              //       canceledBookings={cancelledBookings}
              //     />
              //   ) : (
              //     <Navigate to="/login" />
              //   )
              // }
            />
            <Route
              path="/notifications"
              element={
                (user &&
                  user.status === "active" &&
                  dbAppTypeDocuments &&
                  dbAppTypeDocuments.apptype === "lite") ||
                (dbAppTypeDocuments && dbAppTypeDocuments.apptype === "pro") ? (
                  <Notification />
                ) : (
                  <Navigate to="/login" />
                )
              }
            ></Route>
            <Route path="/products-two" element={<PGProducts />} />

            <Route
              path="/product-details/:productId"
              element={<ProductDetails />}
            />

            <Route path="/subscription-details" element={<PGSubscription />} />
            <Route
              path="/product-images/:productId"
              element={<ProductImages />}
            />
            <Route
              path="/accommodation-booking"
              element={<PGAccommodationBooking />}
            ></Route>
            <Route
              path="/accommodation-details"
              element={<AccommodationPropertiesDetails />}
            ></Route>
            <Route
              path="/accommodation-checkout"
              element={<AccommodationCheckout />}
            ></Route>
            <Route
              path="/accommodation-dashboard"
              element={<AccommodationBookingDashboard />}
            ></Route>
            <Route path="/new-dragging-page" element={<MyGridLayout />}></Route>
            <Route
              path="/career"
              element={
                dbPagesControlDocuments &&
                dbPagesControlDocuments.career === true && <PGCareer />
              }
            ></Route>
            <Route path="/our-team" element={<PGTeam />}></Route>
            <Route
              path="/events"
              element={
                dbPagesControlDocuments &&
                dbPagesControlDocuments.events === true && <PGEvents />
              }
            ></Route>
            <Route path="/blog-articles" element={<BlogAndArticles />}></Route>
            <Route path="/blog-details/:id" element={<BlogDetails />}></Route>
            {/* <Route
            path="/admindashboard"
            element={
              user && user.role === "admin" ? (
                <PGAdminDashboard />
              ) : (
                <Navigate to="/login" />
              )
            }
          ></Route> */}
            <Route
              path="/sitesettings"
              element={
                (user && user.role === "admin") || "superAdmin" ? (
                  <AppSettings />
                ) : (
                  <Navigate to="/login" />
                )
              }
            ></Route>

            <Route
              path="/vendor-registration/:vendorProfileId"
              element={user && user && <PGVendorRegistration />}
            ></Route>
            <Route
              path="/manage-account/:vendorProfileId"
              element={user && user && <PGVendorManageAccount />}
            ></Route>

            <Route
              path="cart"
              element={
                user && user.status === "active" ? <Cart /> : <PGLoginSignUp />
              }
            ></Route>

            {/* <Route
              path="/cart"
              element={user && user ? <Cart /> : <Navigate to="/login" />}
            ></Route> */}
            <Route
              path="/privacy-policy"
              element={<CorporateTwoPolicy />}
            ></Route>
            <Route
              path="/term-condition"
              element={<CorporateTwoTerms />}
            ></Route>
            <Route path="/enquries-list" element={<AllContactData />}></Route>

            <Route
              path="/checkout/:id"
              element={
                user && user.status === "active" ? (
                  <Checkout />
                ) : (
                  // <Navigate to="/login" />
                  <PGLoginSignUp />
                )
              }
            ></Route>

            <Route path="/ordersummary/:id" element={<OrderSummary />} />
            <Route
              path="/orders"
              element={user && user ? <OrdersPage /> : <Navigate to="/login" />}
            />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/address" element={<Address />} />
            <Route path="/order-details/:id" element={<OrderDetails />} />
            <Route path="/admin-panel/*" element={<AdminRoutes />} />
            <Route path="/customer-panel/*" element={<CustomerRoutes />} />
            <Route path="/onlinepayment" element={<OnlinePayment />} />
            <Route path="/quick-pickup" element={<QuickPickup />} />
            <Route
              path="/quick-pickup-summary/:id"
              element={<QuickPickupSummary />}
            />
            <Route
              path="/quick-pickup-product-add/:id"
              element={<QuickPickupProductAdd />}
            />
            <Route path="/reorder/:id" element={<Reorder />} />

            {/* // products two */}
            <Route path="/products-two" element={<Productstwo />} />
            <Route
              path="/product-details-two/:id"
              element={<ProductDetailTwo />}
            />
            <Route path="/loyalty-panel" element={<LoyaltyPanel />} />
            {/* dead cart */}
            <Route path="/dead-cart" element={<DeadCart />} />

            <Route path="/profile-two" element={<ProfileTwo />} />

            <Route path="/offline-order" element={<OfflineOrder />} />

            <Route path="/price-page" element={<PricePage />} />

            <Route path="/order-receipt-view/:orderId" element={<OrderReceiptView/>}/>

            <Route
              path="/all-users"
              element={
                (user && user.role === "admin") || "superAdmin" ? (
                  <PGAdminUser />
                ) : (
                  <Navigate to="/login" />
                )
              }
            ></Route>
            <Route
              path="/user-detail/:userProfileId"
              element={
                user ? (
                  //removed (&& user.role === "admin") by Kaartik on 24th feb
                  <UserDetail />
                ) : (
                  <Navigate to="/login" />
                )
              }
            ></Route>
            <Route path="/profile" element={<PGBusinessThreeProfile />} />
            <Route
              path="/addphoto"
              element={
                user && user.role === "admin" ? (
                  <AddPhoto />
                ) : (
                  <Navigate to="/login" />
                )
              }
            ></Route>
            {/* <Route
              path="/adddocument"
              element={
                user && user.role === "admin" ? (
                  <AddDocument />
                ) : (
                  <Navigate to="/login" />
                )
              }
            ></Route> */}
            <Route path="/returnpolicy" element={<ReturnPolicy />}></Route>
            <Route path="/contact" element={<ContactUs />}></Route>
            <Route
              path="/ticketdetail"
              element={
                (user &&
                  user.status === "active" &&
                  dbAppTypeDocuments &&
                  dbAppTypeDocuments.apptype === "liteplus") ||
                (dbAppTypeDocuments && dbAppTypeDocuments.apptype === "pro") ? (
                  <TicketDetail />
                ) : (
                  <Navigate to="/login" />
                )
              }
            ></Route>
            <Route
              path="/createticket"
              element={
                user && user.status === "active" ? (
                  <CreateTicket />
                ) : (
                  <Navigate to="/login" />
                )
              }
            ></Route>
            <Route
              path="/bookinglist"
              element={user ? <BookingList /> : <Navigate to="/login" />}
            ></Route>
            <Route path="/gallery" element={<PGGallery />}></Route>
            <Route path="/faq" element={<PGFaq />}></Route>
            <Route path="/partnerslider" element={<PartnerSlider />}></Route>
            <Route path="/login" element={<PGLoginSignUp />}></Route>
            <Route path="/aboutus" element={<PGBusinessThreeAboutUs />} />

            <Route path="/botify" element={<ChatBot />} />
            <Route
              path="/leave-history"
              element={user && user ? <LeaveHistory /> : <PGLoginSignUp />}
            ></Route>

            <Route
              path="/attendance"
              element={
                user && user.status === "active" ? (
                  <PGAttendance />
                ) : (
                  // <Navigate to="/login" />
                  <PGLoginSignUp />
                )
              }
            ></Route>

            <Route
              path="/attendance-dashboard"
              element={
                user &&
                (user.role === "hr" ||
                  user.role === "superAdmin" ||
                  user.role === "admin") ? (
                  <PGHrAttendance />
                ) : (
                  <Navigate to="/profile" />
                )
              }
            ></Route>
            {/* Dynamic Route to Handle Document ID */}
            <Route path="/page/:id" element={<DynamicPages />} />
            {/* 404 Page Not Found Route */}
            <Route
              path="*"
              element={
                excludedPaths.some(
                  (path) =>
                    location.pathname === path ||
                    location.pathname.startsWith(path + "/")
                ) ? (
                  <></> // or some fallback UI
                ) : (
                  <PageNotFound />
                )
              }
            />
          </Routes>
        </Suspense>
      </div>
      <NavbarBottomTwo />
      {/* <FooterUpper /> */}
      <FloatingSpeedDial />
      {/* <Footer /> */}
      <ColorsComponent />
    </>
  );
}

export default GlobalRoute;
